import { sendEventToGTM } from '~/utils/gtmUtils';

//used for Google Analytics events
const sendAnalyticEvent = (event: string) => {
  sendEventToGTM(event);
};

export default sendAnalyticEvent;
